import PaginationState from '../pagination/PaginationState'
import Page from '../pagination/Page'
import App from '../App'

import { Client as RevasClient } from '@revas/ts-api'

export default class ListPinnedAppsPagination extends PaginationState<App> {
  revasClient: RevasClient | null = null

  constructor (revasClient: RevasClient, pageSize: number, search: string) {
    super(pageSize, search)
    this.revasClient = revasClient
  }

  async asyncRequestPage (token: string): Promise<[Page<App>, string]> {
    if (this.revasClient === null) {
      throw new Error('client is null')
    }
    const apps: App[] = []
    const appsResponse = await this.revasClient.asyncRevasPost('/launchpad/launchpad.ListPinnedApps/', {
      pageSize: this.pageSize,
      pageToken: token,
      search: this.search
    })

    appsResponse.apps.forEach((app: App) => {
      apps.push(app)
    })

    let nextPageToken = appsResponse.nextPageToken
    while (nextPageToken !== '') {
      const response = await this.revasClient.asyncRevasPost('/launchpad/launchpad.ListPinnedApps/', {
        pageSize: this.pageSize,
        pageToken: nextPageToken,
        search: this.search
      })
      appsResponse.apps.forEach((app: App) => {
        apps.push(app)
      })
      nextPageToken = response.nextPageToken
    }

    const newPage = new Page<App>()
    newPage.items = apps

    return [newPage, '']
  }

  clone (): PaginationState<App> {
    if (this.revasClient === null) {
      throw new Error('revas client is null')
    }
    const p = new ListPinnedAppsPagination(this.revasClient, this.pageSize, this.search)
    p.tokens = this.tokens
    p.currentPage = this.currentPage
    return p
  }
}
